export const colors = {
  primary: '#B63422',
  secondary: '#CF7761',
  white: '#ffffff',
  black: '#000000',
  light: '#E4AE92',
  exLight: '#FEF5CE',
  green: '#418e8c',
};
